import { DoubleSide, MeshStandardMaterial, ShaderLib, UniformsUtils } from 'three';

import { defaultHooks, modifySource } from '@resn/gozer-three';

import {
    uniforms as ripHighlightUniforms,
    shaderChunks as ripHighlightChunks,
} from './snippets/ripHighlight.glsl.js';

class PackWaxMaterial extends MeshStandardMaterial {
    constructor(props) {
        props = Object.assign(
            {
                color: '#ffffff',
                side: DoubleSide,
                fog: true,
                transparent: false,
            },
            props
        );
        super(props);

        this.defines = {
            STANDARD: '',
            USE_FOG: true,
            USE_FOG_ALPHA: false,
            USE_UV: true,
            ...props.defines,
        };

        const uniforms = (this.uniforms = UniformsUtils.merge([
            ShaderLib.standard.uniforms,
            {
                fogNear: { value: 3 },
                fogFar: { value: 1 },
                ...ripHighlightUniforms(),
            },
        ]));

        this.onBeforeCompile = (shader) => {
            shader.uniforms = uniforms;
            shader.vertexShader = modifySource(
                shader.vertexShader,
                {
                    ...defaultHooks.vertexHooks,
                    ...{
                        postFog: '#insertafter:#include <fog_vertex>\n',
                    },
                },
                {
                    uniforms: /* glsl */ `
                        varying vec3 vWorldPosition;
                    `,
                    postFog: /* glsl */ `
                        vWorldPosition = worldPosition.xyz;
                    `,
                }
            );

            shader.fragmentShader = modifySource(
                shader.fragmentShader,
                {
                    ...defaultHooks.fragmentHooks,
                    ...{
                        repFragMap: '#replace:#include <map_fragment>\n',
                        preLights: '#insertbefore:#include <lights_physical_fragment>\n',
                        repFog: '#replace:#include <fog_fragment>\n',
                    },
                },
                {
                    uniforms: /* glsl */ `
                        varying vec3 vWorldPosition;
                        
                        ${ripHighlightChunks.uniforms}
                    `,
                    preFragColor: /* glsl */ `
                        #ifdef USE_ALPHAMAP
                            if(texture2D(alphaMap, vAlphaMapUv).g < 0.5) discard;
                        #endif
                    `,
                    repFragMap: /* glsl */ `
                        #ifdef USE_MAP
                            vec4 sampledDiffuseColor = texture2D( map, vMapUv );
                            diffuseColor.rgb *= gl_FrontFacing ? sampledDiffuseColor.rgb : vec3(0.5);
                        #endif
                    `,
                    preLights: /* glsl */ `
                        metalnessFactor = gl_FrontFacing ? metalness : 0.85;
                        roughnessFactor = gl_FrontFacing ? roughness : 0.10;
                    `,
                    repFog: /* glsl */ `
                        #ifdef USE_FOG
                            float fogFactor = smoothstep(fogNear, fogFar, vWorldPosition.z);
                            gl_FragColor.rgb *= fogFactor;
                        #endif
                        #ifdef USE_FOG_ALPHA 
                            float fogFactorA = smoothstep(fogNear, fogFar, vWorldPosition.z);
                            gl_FragColor.a *= fogFactorA;
                        #endif
                        
                        // gl_FragColor = vec4(vUv, 0.0, 1.0);
                        
                        ${ripHighlightChunks.fragment}

                        // gl_FragColor = vec4(gl_FragColor.rgb, 1.0);
                        // gl_FragColor = vec4(vec3(highlightWave), 1.0);
                    `,
                }
            );
        };
    }
}
export default PackWaxMaterial;
